<template>
  <el-row>
    <el-col :span="6" class="cs-contentContainer-left">
      <div>&nbsp;</div>
    </el-col>
    <el-col :span="12" class="cs-fullHeight cs-contentContainer-middle">
      <div class="cs-fullHeight-content">
        <div class="backgroud-white cs-content-main">
          <div>
            <el-row>
              <el-col>
                <img v-if="isSuccess" src="@/assets/success.png" />
                <img v-else src="@/assets/disabled.png" />
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <h4 v-if="isSuccess">付款成功</h4>
                <h4 v-else>付款已取消</h4>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                {{seconds}}秒后自动跳转回账单详情页面
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :span="6" class="cs-contentContainer-right">
      <div>&nbsp;</div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "stripeSuccess",
  data() {
    return {
      isSuccess: true,
      seconds: 10
    };
  },
  created() {
    this.isSuccess = this.$route.query.isSuccess == "1";
    if (this.isSuccess){
      this.seconds = 10;
    }else{
      this.seconds = 3;
    }
   
    setInterval(() => {
      this.seconds --;
      if (this.seconds <= 0){
        window.location.href = `/addCollectFees/autonomousList?enrollmentType=${this.$route.query.enrollmentType}&accountId=${this.$route.query.accountId}`;
      }
    }, 1000);
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
.cs-contentContainer-middle {
  display: flex;
  justify-content: center;
  align-items: center;

  .cs-fullHeight-content {
    width: 100%;

    .cs-content-main {
      height: 500px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-row {
        padding: 30px;

        .el-col {
          text-align: center;
        }
      }
    }

    .cs-content-bottom {
      height: 60px;

      footer {
        line-height: 60px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/stripe/response.vue